export default __webpack_public_path__ + "static/media/Aura-Egg__20.848cb16f.png";